module.exports = __webpack_public_path__ + "media/images/arrows-up-87884df8d28c6d483b5f74a3d770668c.svg";